export default class SendJobToWorkersRequest {
    workerIds: string[];
    sendWorkerEmail: boolean;
}